import { Permission } from 'modules/user/api/interfaces'
import { Permissions } from 'modules/user/constants/permissions'

export const checkPermission = (permissions: Permission[] | undefined, checkedPermission: Permissions) =>
  !!permissions?.find((item) => item.code === checkedPermission)
